<template>
  <v-app-bar app clipped-left clipped-right height="55" extension-height="45">
    <v-app-bar-nav-icon dark @click="$store.dispatch('SetNavigationDrawer', !drawer)"></v-app-bar-nav-icon>
    <!--    <router-link to="/" v-if="$vuetify.breakpoint.mdAndUp">-->
    <router-link to="/monitoring" replace>
      <v-img
        :src="require('@/assets/image/monitoring/HiSMART.png')"
        height="24"
        width="200"
        class="mr-5"
      ></v-img>
    </router-link>
    <h3 class="blue--text text--darken-4">{{systemName}}</h3>
    <!--    <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:extension>-->
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-tabs fixed-tabs mobile-breakpoint="960" v-model="tabIndex">
        <v-tab
          style="color:#DAEFFE;"
          v-for="menu in highMenus"
          :key="'menu_1depth_' + menu.menu_id"
          @click="changeRootMenu(menu)"
          class="subtitle-1"
        >
          <v-icon left v-if="menu.icon_path">{{ menu.icon_path }}</v-icon>
          {{ $t(menu.menu_id) }}
        </v-tab>
      </v-tabs>
      <!-- 즐겨찾기 버튼 -->
      <!--      <v-toolbar-items class="pr-4">-->
      <!--        <v-btn small icon @click="toggleBookMark" v-if="!bookMark"><v-icon color="yellow">mdi-star-outline</v-icon></v-btn>-->
      <!--        <v-btn small icon @click="toggleBookMark" v-else><v-icon color="yellow">mdi-star</v-icon></v-btn>-->
      <!--        <v-btn small icon @click="toggleDrawerRight"> <v-icon>mdi-calendar-text-outline</v-icon></v-btn>-->
      <!--      </v-toolbar-items>-->
    </template>
    <v-spacer/>
    <!-- MOBILE -->
    <v-toolbar-items v-if="$vuetify.breakpoint.smAndDown">
      <v-btn dark icon v-on:click="search">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-menu
        v-model="mobileMenu"
        offset-x
        :close-on-content-click="false"
        v-if="$vuetify.breakpoint.smAndDown"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <!-- 즐겨찾기 -->
            <!--            <v-list-item class="justify-center">-->
            <!--              <v-btn small icon @click="toggleBookMark" v-if="!bookMark"><v-icon color="yellow">mdi-star-outline</v-icon></v-btn>-->
            <!--              <v-btn small icon @click="toggleBookMark" v-else><v-icon color="yellow">mdi-star</v-icon></v-btn>-->
            <!--            </v-list-item>-->
            <!-- 다국어 -->
            <!--            <v-list-item>-->
            <!--              <v-btn-toggle rounded v-model="selectedLocale" class="align-center mx-1" color="primary">-->
            <!--                <v-btn @click="changeLocale('ko')" small color="gray">-->
            <!--                  KOR-->
            <!--                </v-btn>-->
            <!--                <v-btn @click="changeLocale('en')" small color="gray">-->
            <!--                  ENG-->
            <!--                </v-btn>-->
            <!--              </v-btn-toggle>-->
            <!--            </v-list-item>-->
            <!-- 다크 모드 -->
            <v-list-item class="justify-center">
              <v-switch
                v-model="$vuetify.theme.dark"
                hide-details
                :label="$vuetify.theme.dark ? 'Dark' : 'Light'"
                class="ma-0"
              ></v-switch>
            </v-list-item>
            <!-- color -->
            <!--            <v-list-item class="justify-center" v-for="color in theme.colors" :key="color">-->
            <!--              <v-btn-->
            <!--                @click="changeColor(color)"-->
            <!--                small-->
            <!--                :color="color"-->
            <!--              />-->
            <!--            </v-list-item>-->
          </v-list>
          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="mobileMenu = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <!--      <v-btn small icon @click="toggleDrawerRight"> <v-icon>mdi-calendar-text-outline</v-icon></v-btn>-->
    </v-toolbar-items>
    <!-- PC -->
    <v-toolbar-items v-else-if="isSigned">
      <v-btn dark text @click="$router.push('/mypage')">{{ $store.state.user.userName }}</v-btn>
      <v-divider class="mx-1" vertical inset></v-divider>
      <v-btn dark text @click="clickLogout">로그아웃</v-btn>
      <v-divider class="mx-1" vertical inset></v-divider>
      <!--      <v-btn samll text to="">도움말</v-btn>-->
      <!--      <v-divider-->
      <!--        class="mx-1"-->
      <!--        vertical-->
      <!--        inset-->
      <!--      ></v-divider>-->
      <!-- dark mode -->
      <v-switch
        dark
        v-model="$vuetify.theme.dark"
        hide-details
        :label="$vuetify.theme.dark ? 'Dark' : 'Light'"
        class="align-center mx-1"
      ></v-switch>
      <!-- 알람 -->
      <!--      <v-badge-->
      <!--        bordered-->
      <!--        color="error"-->
      <!--        content="2"-->
      <!--        overlap-->
      <!--        class="align-self-center mr-4"-->
      <!--      >-->
      <!--        <v-btn small icon to=""><v-icon>mdi-bell-outline</v-icon></v-btn>-->
      <!--      </v-badge>-->
      <!-- 색상변경 -->
      <!--      <v-btn small icon @click="colorBoxVisible = !colorBoxVisible"><v-icon :color="theme.selectedColor">mdi-image</v-icon></v-btn>-->
      <!--      <div class="theme-btn-group" v-if="colorBoxVisible">-->
      <!--        <v-btn-->
      <!--          v-for="color in theme.colors"-->
      <!--          :key="color"-->
      <!--          @click="changeColor(color)"-->
      <!--          small-->
      <!--          icon-->
      <!--        ><v-icon :color="color">mdi-square</v-icon></v-btn>-->
      <!--      </div>-->
      <!-- i18n 언어 변경 -->
      <!--      <v-menu-->
      <!--        bottom-->
      <!--        left-->
      <!--        offset-y-->
      <!--        origin="top right"-->
      <!--        transition="scale-transition"-->
      <!--        open-on-hover-->
      <!--      >-->
      <!--        <template v-slot:activator="{ on }">-->
      <!--          <v-btn small icon v-on="on"><v-icon>{{ $t('i18n-btn') }}</v-icon></v-btn>-->
      <!--        </template>-->
      <!--        <v-card>-->
      <!--          <v-list>-->
      <!--            <v-list-item-->
      <!--              v-for="(locale, i) in locales"-->
      <!--              :key="i"-->
      <!--              link-->
      <!--              class="justify-end"-->
      <!--            >-->
      <!--              <v-btn text block @click="changeLocale(locale.id)">-->
      <!--                {{ locale.name }}-->
      <!--              </v-btn>-->
      <!--            </v-list-item>-->
      <!--          </v-list>-->
      <!--        </v-card>-->
      <!--      </v-menu>-->
      <!-- 전체화면 -->
      <v-btn dark small icon @click="$emit('expand')">
        <v-icon>mdi-arrow-expand-all</v-icon>
      </v-btn>
    </v-toolbar-items>

    <v-dialog v-model="popup" persistent max-width="450px">
      <mini-search-popup
        @closeDetailPop="popup=false"
        :detail="paramTitle"
        status="search"
      ></mini-search-popup>
    </v-dialog>
    <!-- PC 상단 메뉴 -->
  </v-app-bar>
</template>
<script>
import store from '@/store'
import envs from '@/envs'
import localStore from '@/utils/localStore'
import { saveMyMenu } from '@/api/common/user'
import _ from 'lodash'
import Message from '@/utils/message'
import MiniSearchPopup from '@/components/mobile/MiniSearchPopup'
import Cookies from 'js-cookie'

export default {
  name: 'AppHeader',
  components: {
    MiniSearchPopup
  },
  data: () => ({
    searchParam: '',
    paramList: [],
    paramTitle: '',
    paramStatus: 'search',
    popup: false,
    mobileMenu: false,
    selectedLocale: 0,
    locales: envs.framework.supportLocales,
    colorBoxVisible: null,
    theme: {
      selectedColor: '#014085',
      colors: ['#014085', '#018f7f', '#F46C59']
    },
    bookMarkMenuInfo: [], // 북마크 저장시 사용할 현재 메뉴 정보
    userName: ''
  }),
  computed: {
    highMenus() {
      return store.state.menu.menus.filter(menu => (menu.menulevel | 0) === 1)
    },
    drawer() {
      return store.state.menu.flag.navigationDrawer
    },
    systemName() {
      return envs.name
    },
    isSigned() {
      // login session이 있을 경우 token 값이 존재한다.
      return !!store.getters.token
    },
    tabIndex: {
      get() {
        return store.state.menu.tabIndex
      },
      set(val) {
        this.$store.dispatch('SetTabIndex', val)
      }
    },
    bookMark() {
      // 현재 화면이 마이 메뉴에 속한 메뉴인지 확인한다
      var bookMarkMenu = this.$store.state.user.myMenu.find(menuItem => {
        return menuItem.href === this.$route.path
      })
      if (bookMarkMenu) {
        // 현재 화면이 myMenu 에 속한 화면이면
        return true // 북마크 별을 칠해준다.
      } else {
        // myMenu에 속한 화면이 아니면
        return false // 북마크 별을 해제해준다.
      }
    }
  },
  watch: {
    '$store.state.user.userName'(newVal) {
      this.userName = newVal
    }
  },
  created() {
    // 이전에 저장된 컬러 값이 있을 경우 가져와 반영한다.
    let localSavedColor = localStore.get('theme-color')
    if (!localSavedColor) {
      localSavedColor = '#014085'
    }
    this.changeColor(localSavedColor)
  },
  methods: {
    clickLogout() {
      Cookies.remove('autoLogin')
      this.$router.replace('/logout')
    },
    search() {
      this.popup = true
      this.searchParam = ''
      this.paramList = []
    },
    changeLocale(command) {
      store.dispatch('SetLocale', command)
    },
    changeColor(color) {
      this.$vuetify.theme.themes.light.primary = color
      this.$vuetify.theme.themes.light.inquiry = color
      this.theme.selectedColor = color
      this.colorBoxVisible = false
      localStore.set('theme-color', color)
    },
    changeRootMenu(menu) {
      const selectedMenu = this.$store.state.menu.selectedMenu
      const open = store.state.menu.flag.navigationDrawer
      if (menu.menu_id === selectedMenu.menu_id) {
        if (menu.children) {
          this.$store.dispatch('SetNavigationDrawer', !open)
        }
      } else {
        this.$emit('changeMenu', menu)
      }
      // if (menu.menu_id !== selectedMenu.menu_id) {
      //   this.$emit('changeMenu', menu)
      // } else {
      //   console.log(menu)
      //   this.$store.dispatch('SetNavigationDrawer', !open)
      // }
    },
    toggleBookMark() {
      // 현재 메뉴 정보를 전체 메뉴에서 찾아온다
      this.bookMarkMenuInfo = _.cloneDeep(
        this.$store.state.menu.menus.find(menuItem => {
          return menuItem.href === this.$route.path
        })
      )
      // 현재 북마크 값이 false 이면
      if (!this.bookMark) {
        // 추가하는 메뉴는 무조건 1레벨로 추가한다.
        this.bookMarkMenuInfo.menulevel = 1
        this.bookMarkMenuInfo.prnts_mymenu_id = '#'
        this.bookMarkMenuInfo.mymenu_nme = this.bookMarkMenuInfo.title
        // 마이메뉴 상에서 생성된 메뉴와 구분하기 위한 데이터 셋팅
        this.bookMarkMenuInfo['node_type'] = 'M'
        let bookMarkSaveData = {
          created: [],
          retrieveData: { userId: this.$store.state.user.userId }
        } // 신규로 마이메뉴 추가
        bookMarkSaveData.created.push(this.bookMarkMenuInfo)
        saveMyMenu(bookMarkSaveData)
          .then(res => {
            this.getMyMenu()
            Message.success('즐겨찾기 메뉴가 추가되었습니다.') // 성공시 메시지를 표시한다.
          })
          .catch(() => {
            Message.err('잠시 후 다시 시도해주세요.') // API 에러시 메시지를 표시한다
          })
      } else {
        // 북마크 값이 false 이면
        let bookMarkSaveData = {
          deleted: [],
          retrieveData: { userId: this.$store.state.user.userId }
        } // 기존에 존재하던 마이메뉴 삭제
        bookMarkSaveData.deleted.push(this.bookMarkMenuInfo)
        saveMyMenu(bookMarkSaveData)
          .then(res => {
            this.getMyMenu()
            Message.success('즐겨찾기 메뉴가 삭제되었습니다.') // 성공시 메시지를 표시한다
          })
          .catch(() => {
            Message.err('잠시 후 다시 시도해주세요.') // API 에러시 메시지를 표시한다
          })
      }
    },
    getMyMenu() {
      // myMenuList 를 조회하는 함수
      store.dispatch('GetMyMenu', store.state.user.userId).then(() => {})
    },
    toggleDrawerRight() {
      const toggle = store.state.menu.flag.bookMarkDrawer
      store.dispatch('SetBookmarkDrawer', !toggle)
    }
  }
}
</script>
<style lang="scss" scoped>
.v-divider--vertical {
  margin-top: 21px !important;
  min-height: 0 !important;
  max-height: calc(100% - 40px) !important;
}

.v-toolbar__extension {
  // background-color: #0a3564;
  padding-right: 0;
}

.theme-btn-group {
  align-self: center;
}
</style>
